import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const upflowIframeComponentEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-upflow-iframe-entrypoint" */ './main').then(
			({ UpflowIframeComponent }) => UpflowIframeComponent,
		),
	),
	getPreloadProps: () => ({}),
});
